import ExternalLink from 'components/ExternalLink/ExternalLink'
import { getExplorerUrl } from 'config/chains'
import cx from 'classnames'
import { ImSpinner2 } from 'react-icons/im'
import { ReactNode } from 'react'
import useWallet from 'rfx/lib/wallets/useWallet'

export type TransactionStatusType = 'muted' | 'loading' | 'success' | 'error'

type Props = {
  status: TransactionStatusType
  text: ReactNode
  txnHash?: string
  onSpeedUp?: (hash?: string) => void
  speedUpDelayMs?: number
}
// type RecentTxn = { hash: string; [key: string]: any }

export function TransactionStatus({
  status,
  text,
  txnHash,
  onSpeedUp,
  speedUpDelayMs = 5000,
}: Props) {
  // eslint-disable-next-line no-console
  console.log({ status, text, txnHash, onSpeedUp, speedUpDelayMs })
  const { chainId } = useWallet()
  const txnLink = txnHash
    ? `${getExplorerUrl(chainId)}tx/${txnHash}`
    : undefined
  // const [showSpeedUp, setShowSpeedUp] = useState(false)

  // const recentTxns = commonStore((store) => store.recentTxns) as RecentTxn[]

  // useEffect(() => {
  //   if (status === 'loading') {
  //     const timer = setTimeout(() => setShowSpeedUp(true), speedUpDelayMs)
  //     return () => clearTimeout(timer)
  //   } else {
  //     setShowSpeedUp(false)
  //   }
  // }, [status, speedUpDelayMs])

  return (
    <div className="flex flex-col">
      <div className="mt-2 flex items-center gap-4 text-xs text-patek-neutral-celestial-grey-500">
        <div
          className={cx('TransactionStatus-title w-[200px] capitalize', {
            muted: status === 'muted',
          })}
        >
          {text}
        </div>
        <div className="TransactionStatus-status mt-1 flex items-center gap-2">
          {status === 'loading' && (
            <ImSpinner2
              width={60}
              height={60}
              className="spin TransactionStatus-spin"
            />
          )}
          {/* {recentTxns && recentTxns.length > 0 && !txnHash && (
            <>
              {onSpeedUp && showSpeedUp && (
                <div
                  className="ml-2 cursor-pointer text-xs text-th-active"
                  onClick={() => onSpeedUp(recentTxns?.[0]?.hash)}
                >
                  Speed Up
                </div>
              )}
            </>
          )} */}

          {status !== 'loading' && txnHash && txnLink && (
            <ExternalLink href={txnLink} className="text-th-active">
              VIEW
            </ExternalLink>
          )}
        </div>
      </div>
      {/* {showSpeedUp && status === 'loading' && (
        <div className="mt-2 text-xs">
          HyperEVM maybe congested or RPC maybe down. Please change your RPC or
          try again in some time.
        </div>
      )} */}
    </div>
  )
}
